import axiosConfig from "./axiosConfig";

const deleteAxpoCounterInvoice = async (
  authToken: string,
  pairingId: string
): Promise<void> => {
  const { data } = await axiosConfig.delete(
    `/admin/axpo-counter-invoice/${pairingId}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default deleteAxpoCounterInvoice;
